import "./App.css";

import { BrowserRouter } from "react-router-dom";

// Component
import MyRouter from "./Router";

// utility
import Snackbar from "./Components/utility/Snackbar";
import ErrorBound from "./Components/utility/ErrorBound";

import { ThemeProvider } from "@mui/material";
import { Theam } from "./Components/Theam";
import { createContext, useReducer, useMemo } from "react";
import reducer from "./Components/ContextAPI/Reducer";
import getToken from "../src/Services/getToken";

const AuthContext = createContext();

const initialState = {
  login: {},
  adminReCall: false,
  alert: {
    open: false,
    variant: null,
    message: null,
  },
};

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);
  console.log("App Component");
  console.log(getToken(), "token");
  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
console.log(state, "auth");
  return (
    <AuthContext.Provider value={contextValue}>
      <ThemeProvider theme={Theam}>
        <ErrorBound fallback={"Sorry for the inconvenience !!! "}>
          <BrowserRouter>
            <Snackbar />
            <MyRouter />
          </BrowserRouter>
        </ErrorBound>
      </ThemeProvider>
    </AuthContext.Provider>
  );
}

export { AuthContext };

export default App;
